// @flow
import { deleteCreator, getCreator, postCreator } from '../../../http';
import environment from '../../../environment';
import { Address, Country } from '../../../entities';

export type DisbursementBankRequest = {
  bankId: number;
  specialCode: string;
  accountNumber: string;
  billingAddress: Address;
};

export type DisbursementPaypalRequest = {
  authorizationToken: string;
  country: Country;
};

export const endpoints = Object.freeze({
  SEARCH_ADMIN1: `${environment.apiUrl}/geography/location/:country`,
  SEARCH_ADMIN2: `${environment.apiUrl}/geography/location/:country/:admin1`,
  SEARCH_ADMIN3: `${environment.apiUrl}/geography/location/:country/:admin1/:admin2`,
  FETCH_PAYOUT: `${environment.apiUrl}/preferences/disbursement`,
  POST_PAYOUT: `${environment.apiUrl}/preferences/disbursement/bank`,
  POST_PAYOUT_PAY_PAL: `${environment.apiUrl}/preferences/disbursement/paypal`,
  DELETE_PAYOUT: `${environment.apiUrl}/preferences/disbursement`,
  PAYOUT_METHODS: `${environment.apiUrl}/meta/disbursement-methods/:country`,
  BANKS: `${environment.apiUrl}/meta/banks/:country`,
});

export const searchAdmin1Api = getCreator(fetch, endpoints.SEARCH_ADMIN1);
export const searchAdmin2Api = getCreator(fetch, endpoints.SEARCH_ADMIN2);
export const searchAdmin3Api = getCreator(fetch, endpoints.SEARCH_ADMIN3);
export const getPayoutsApi = getCreator(fetch, endpoints.FETCH_PAYOUT);
export const postPayoutApi = postCreator(fetch, endpoints.POST_PAYOUT);
export const postPayoutPayPalApi = postCreator(fetch, endpoints.POST_PAYOUT_PAY_PAL);
export const deletePayoutApi = deleteCreator(fetch, endpoints.DELETE_PAYOUT);
export const getPayoutMethodsApi = getCreator(fetch, endpoints.PAYOUT_METHODS);
export const getBanksApi = getCreator(fetch, endpoints.BANKS);



// WEBPACK FOOTER //
// ./src/modules/preferences/payouts/api.js